import script from "./StoreSingle.vue?vue&type=script&setup=true&lang=js"
export * from "./StoreSingle.vue?vue&type=script&setup=true&lang=js"

import "./StoreSingle.vue?vue&type=style&index=0&id=595e25c2&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-595e25c2"]])

export default __exports__